// extracted by mini-css-extract-plugin
export default {"scrollTop":"ToTopButton_scrollTop__WODrw"};